import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AccueilComponent } from './accueil/accueil.component';
import { LoginComponent } from './admin/login/login.component';
import { DashboardComponent } from './admin/dashboard/dashboard.component';
import { AuthGuard } from './admin/auth.guard';

// Le site public est desormais une seule page qui defile (one-page), comme le prototype HTML :
// toutes les sections (programme, artistes, archives, theatre, decouvrir) vivent dans
// AccueilComponent et sont atteintes par ancre (#programme, #artistes...) plutot que par route.
// Les anciennes URLs /programme, /artistes, etc. sont conservees en redirection avec fragment,
// pour ne pas casser d'anciens liens/favoris.
const routes: Routes = [
  { path: '', component: AccueilComponent },

  { path: 'programme', redirectTo: '/#programme' },
  { path: 'artistes', redirectTo: '/#artistes' },
  { path: 'archives', redirectTo: '/#archives' },
  { path: 'theatre', redirectTo: '/#theatre' },
  { path: 'decouvrir', redirectTo: '/#decouvrir' },

  // Routes du back-office
  { path: 'admin/login', component: LoginComponent },
  { path: 'admin/dashboard', component: DashboardComponent, canActivate: [AuthGuard] },

  // Filet de securite : toute URL qui ne correspond a rien (lien casse, historique
  // du navigateur, etc.) redirige vers l'accueil au lieu de faire planter l'application.
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }

